<template>
  <v-card :color="color">
    <!-- <v-card-title :class="titleClass">
      <h3 :class="titleTextClass">{{title}}</h3>
    </v-card-title> -->
    <v-toolbar card dense flat :color="color">
      <v-toolbar-title :class="titleTextClass">{{title}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <slot name="title-items"></slot>
    </v-toolbar>
    <v-card-text :class="textClass">
      <v-flex v-if="$slots.controls" xs12 pl-4 pr-0 py-1>
        <v-container fluid grid-list-md ma-0 pa-0>
          <v-layout row wrap justify-end>
            <slot name="controls"></slot>
          </v-layout>
        </v-container>
      </v-flex>
      <slot></slot>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    color: {
      default () {
        return 'primary'
      }
    },
    titleTextClass: {
      default () {
        return ['white--text', 'subheading', 'font-weight-thin']
      }
    },
    textClass: {
      default () {
        return ['pt-0', 'px-1', 'pb-1']
      }
    },
    title: {
      type: String
    }
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="scss">

</style>
